import React, { useEffect, useState } from 'react';
import styles from './homePage.module.css';
import { Header } from '../../../components/Header/Header';
import { Slider } from '../../../components/Slider/Slider';
import { useAllItemsQuery } from '../../../store/api/item.api';
import { useLocation } from 'react-router-dom';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard';
import supportIcon from '../../../assets/support-icon.svg';
import { FooterBtn } from '../../../UI/FooterBtn/FooterBtn';

export const KeysHomePage = () => {
	const location = useLocation();

	const schema = location.state?.schema || window.sessionStorage.getItem('schema');

	useEffect(() => {
		window.sessionStorage.setItem('schema', schema);
	}, [schema]);

	const { data: allItems = [], isLoading } = useAllItemsQuery({ schema });

	if (isLoading) return (<div>Loading...</div>);

	// Группировка items по regions.title
	const groupedByKey = allItems.reduce((acc, item) => {
		const groupKey = schema === 'services'
			? item.categories[0]?.title || 'Без категории'
			: item.regions?.title || 'Без региона';

		if (!acc[groupKey]) acc[groupKey] = [];
		acc[groupKey].push(item);
		return acc;
	}, {});

	return (
		<div className={`${styles.homeMain} main`}>
			<Header />
			{Object.entries(groupedByKey).map(([groupTitle, items]) => (
				<div key={groupTitle} className={styles.salesLead_block}>
					<h2>{groupTitle}</h2>
					<Slider sliderType="min" height>
						{items.map(item => (
							<MinSliderCard key={item.id} {...item} itemId={item.id} buyBtn style={{height: 286}} />
						))}
					</Slider>
				</div>
			))}
			<footer className={styles.footer}>
				<FooterBtn
					title="Support"
					url="https://t.me/eazysupp"
					description="На всякий случай, если у вас будут вопросы"
					img={supportIcon}
				/>
			</footer>
		</div>
	);
};
